export const manageHiringPlanRoute = '/recruiter-settings/manage-hiring-plan'
export const createOrEditHiringPlanRoute = '/recruiter/manage-hiring-plan'
export const hiringPlanRoute = '/recruiter/hiring-plan'
export const homePageRoute = '/recruiter/home'
export const addOpeningRoute = `${hiringPlanRoute}/opening/add/new`
export const editOpeningRoute = `${hiringPlanRoute}/opening/edit`
export const viewOpeningRoute = `${hiringPlanRoute}/opening/view`
